import { upperFirst } from 'lodash';
import { SpraypaintBase } from 'spraypaint';
import { createToast } from './FlashToaster';

interface ICreateSuccessfulToastProps {
  /**
   * Attribute or resource name.
   */
  name: string;
  /**
   * Key to pass through to the toast.
   * This is useful if we're managing a toast chain. E.g. this toast was preceded by a loading toast.
   */
  toastKey?: string;
  /**
   * Verb to use when describing the successful action.
   * @default saved
   */
  verb?: string;
}

export function createSuccessfulSaveToast({ name, toastKey, verb = 'saved' }: ICreateSuccessfulToastProps) {
  createToast({
    key: toastKey,
    text: `${upperFirst(name)} was successfully ${verb}`,
    type: 'success',
  });
}

interface ICreateUnsuccessfulToastProps {
  /**
   * Optional message to display before the errors.
   */
  prefix?: string;
  /**
   * Key to pass through to the toast.
   * This is useful if we're managing a toast chain. E.g. this toast was preceded by a loading toast.
   */
  toastKey?: string;
  /**
   * Resource we're updating.
   * The errors will be pulled from this object.
   */
  resource: SpraypaintBase;
}

export function createUnsuccessfulSaveToast({ prefix, toastKey, resource }: ICreateUnsuccessfulToastProps) {
  const errorMessage = Object.keys(resource.errors)
    .map((key) => resource.errors[key].fullMessage)
    .join(', ');
  const text = prefix ? [prefix, errorMessage].join('. ') : errorMessage;
  createToast({ key: toastKey, type: 'error', text });
}
